import React from 'react';

import { HOC } from 'formsy-react';
/* eslint no-unused-vars: 0 */
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import FormInput from './FormInput';

export class MultiSelect extends FormInput {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
        };
    }

    renderLabel() {
        if (!this.props.label) {
            return '';
        }

        if (this.props.labelMobileOnly) {
            return (
                <div className="app__multiselect__label--mobile">
                    { this.props.label }
                </div>
            );
        }

        return <div className="app__multiselect__label">
            { this.props.label }
            <div className="app__multiselect__sublabel">
                { this.props.sublabel }
            </div>
        </div>;
    }

    handleBlur() {
        const event = {
            target: {
                name: this.props.name,
                value: this.state.value,
            },
        };

        super.onBlur(event);
    }

    handleSelectChange(value) {
        const event = {
            target: {
                name: this.props.name,
                value,
            },
        };

        if (this.props.handleChange) {
            this.props.handleChange(event);
        }

        super.onChange(event);

        this.setState({ value });
    }

    render() {
        const widthProportion = this.props.widthProportion ? this.props.widthProportion : 'full';
        const requiredClass = this.showRequired() ? 'app__multiselect__select--required' : '';

        let style = {};
        if (this.props.fixedWidth) {
            style = {
                width: this.props.fixedWidth,
            };
        }

        const className = `app__multiselect__select ${widthProportion} ${requiredClass}`;

        return <div className="app__multiselect">
            { this.renderLabel() }
            <Select multi
                    simpleValue
                    className={ className }
                    style={ style }
                    value={ this.state.value }
                    placeholder="-- Select advice areas --"
                    options={ this.props.options }
                    onBlur={ this.handleBlur.bind(this) }
                    searchable={ false }
                    onChange={ this.handleSelectChange.bind(this) } />
        </div>;
    }
}

MultiSelect.propTypes = {
    label: React.PropTypes.string,
    sublabel: React.PropTypes.string,
    labelMobileOnly: React.PropTypes.bool,
    value: React.PropTypes.node,

    options: React.PropTypes.array,
    optionsType: React.PropTypes.string,
    multiple: React.PropTypes.bool,

    name: React.PropTypes.string,
    handleChange: React.PropTypes.func,
    widthProportion: React.PropTypes.string,
    fixedWidth: React.PropTypes.string,

    invalidSubmit: React.PropTypes.bool,
};

export default HOC(MultiSelect);



// WEBPACK FOOTER //
// ./src/components/elements/MultiSelect.jsx